import React from 'react'

const Footer = () => {
  return (
    <footer className="footer">
        <div>
        <p>© 2023 Your Company. All rights reserved.</p>
        </div>
        <div>
            <input type="text" name="footerInput" placeholder="Enter text here" />
            <button type="submit">Submit</button>
        </div>
    </footer>
  )
}

export default Footer